module.exports = __webpack_public_path__ + "img/big_1_47.0c275730.png";